module.exports = __webpack_public_path__ + "img/side.414f56cf.svg";